import * as React from 'react';
import { styled } from '@mui/material/styles';
import Rating, { IconContainerProps } from '@mui/material/Rating';
import muitoSatisfeito from './assets/apaixonado.png';
import satisfeito from './assets/feliz.png';
import neutro from './assets/confuso.png';
import insatisfeito from './assets/triste.png';
import muitoInsatisfeito from './assets/bravo.png';

const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    color: theme.palette.action.disabled,
  },
  '& .MuiRating-iconEmpty': {
    filter: 'grayscale(100%)',
  },
}));

const StyledIcon = styled('img')({
  width: '50px', 
  height: '50px',
  margin: '10px' 
});

const customIcons: {
  [index: string]: {
    icon: React.ReactElement;
    label: string;
  };
} = {
  1: {
    icon: <StyledIcon src={muitoInsatisfeito} />,
    label: 'Muito insatisfeito',
  },
  2: {
    icon: <StyledIcon src={insatisfeito} />,
    label: 'Insatisfeito',
  },
  3: {
    icon: <StyledIcon src={neutro} />,
    label: 'Neutro',
  },
  4: {
    icon: <StyledIcon src={satisfeito} />,
    label: 'Satisfeito',
  },
  5: {
    icon: <StyledIcon src={muitoSatisfeito} />,
    label: 'Muito satisfeito',
  },
};

interface RadioGroupRatingProps {
  onChange: (value: number) => void;
}

function IconContainer(props: IconContainerProps) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

export default function RadioGroupRating({ onChange }: RadioGroupRatingProps) {
  return (
    <StyledRating
      name="highlight-selected-only"
      IconContainerComponent={IconContainer}
      getLabelText={(value: number) => customIcons[value].label}
      highlightSelectedOnly
      onChange={(_event, value) => onChange(value!)}
    />
  );
}